import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import type { AppAlert, FetchAppAlertsResponse } from './_types';

export function normalizeAppAlert(alert: any): AppAlert {
  return camelcaseKeys(alert, { deep: true }) as AppAlert;
}

export function normalizeAppAlertsResponse(
  data: unknown
): FetchAppAlertsResponse {
  if (Array.isArray(data)) {
    const alerts = data.map(normalizeAppAlert);
    return { alerts, total: alerts.length };
  }

  const response = data as {
    modal_alert?: unknown[];
    meta?: { total?: number };
  };
  const alerts = (response.modal_alert || []).map(normalizeAppAlert);

  return {
    alerts,
    total: response.meta?.total ?? alerts.length,
  };
}

export function denormalizeAppAlert(alert: Partial<AppAlert>) {
  return decamelizeKeys(alert, { deep: true });
}
